import { useQuery } from 'react-query'

import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { APICredential } from 'types'
import { reportError } from 'utils/error'

export function useApiKeys() {
  return useQuery(
    ['api-credentials'],
    async () => {
      const res = await sendToApi<{ api_credentials: APICredential[] }>(`/api-credentials`, { method: 'GET' })
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        reportError('Error loading api credentials', { metaData: res.data })
        throw new Error()
      }
      return res.data
    },
    {
      initialData: () => ({ api_credentials: [] }),
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  )
}
